const NS = 'SiteEmailSubscribeWidget';
const CLS = 'siteEmailSubscribeWidget';

export class SiteEmailSubscribeWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$inputContainer = this.$element.find(`.${CLS}-inputContainer`);
		this.$input = this.$element.find(`.${CLS}-input`);
		this.$sendButton = this.$element.find(`.${CLS}-btn--sendButton`);

		this.$input.focus(() => {
			this.$inputContainer.addClass('focus');
		});

		this.$input.blur(() => {
			this.$inputContainer.removeClass('focus');
		});

		let target = this.$sendButton.attr('data-target');
		this.$sendButton.on('click', (event) => {
			event.preventDefault();
			$(target).find(`input[type='email']`).val(this.$input.val());
		});
	}
}
